import React from "react";
import Arrow_Icon from "../../../Assets/images/arrowIcon.png";

const CustomSuffixIcon = () => {
  return <img src={Arrow_Icon} alt="Icon" />;
};

export default CustomSuffixIcon;